<template>
  <b-modal
    ref="modal"
    size="xl"
    class="text-left job-offer-modal"
    centered
    footer-class="justify-content-center"
    :visible="visible"
    hide-footer
    @hidden="onModalHidden"
  >
    {{ /*remove feature flag on release job builder */ }}
    <div>
      <template slot="modal-header">
        <div class="w-100">
          <h5
            class="modal-title text-center font_size_1125rem font-weight-bold v3_color_teal mt-2"
          >
            Ready to post your job opportunity? 
          </h5>
        </div>
      </template>
      <div class="p-4 v3_color_teal">
        <!-- <a href="https://phairify.com/how-it-works/for-recruiters/">Learn more</a>
      about Phairify Connect and register for a demo. -->
        <!-- Go to the Job Builder to refine this job opportunity and post it to for users to view -->
        <p>
            Great!  Let’s set up your account. You can further refine the specific terms of this position and share it with those interested candidates.
        </p>
        <p>Here’s what’s included (full terms available <a href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Terms_Conditions_Use.pdf" target="_blank"><u>here</u></a>):</p>
        <div>
          <ul>
            <li>Access to specialty-specific compensation and productivity data to inform your offer.</li>
            <li>Immediate delivery of your job opportunity to all interested candidates.</li>
            <li>Our algorithm searches for and includes any new matching candidates for {{ job_opportunity_duration }} days.</li>
            <li>Instant candidate feedback and communications delivered to your Dashboard.</li>
            <li>Connect your opportunity to all matching candidates for ${{ job_opportunity_price }}. Early adopter pricing is available. <a href="mailto:pricinginfo@Phairify.com"><u>Contact us</u></a> to learn more.</li>
          </ul>
        </div>
      
      </div>

      <div class="d-flex align-items-center justify-content-center">
        <!-- <b-button
        variant="v2_primary"
        class="p-4 text-center"
        size="sm"
        @click="redirectToCalendly"
        v-b-tooltip.hover
        :title="applyTooltipText"
      >
        Schedule a Call
      </b-button> -->
        <b-button
          variant="v2_primary"
          class="p-4 text-center"
          size="sm"
          @click="onContinue"
          v-b-tooltip.hover
        >
          Continue
        </b-button>
      </div>
    </div>
    <!-- <div v-else>
      <template slot="modal-header">
        <div class="w-100">
          <h5
            class="modal-title v2_info-popup__title text-center v3_color_teal mt-2"
          >
            Coming Soon!
          </h5>
        </div>
      </template>
      <div class="p-4">
        <a href="https://phairify.com/how-it-works/for-recruiters/">Learn more</a>
        about Phairify Connect and register for a demo.
      </div>
    </div> -->
  </b-modal>
</template>
<script>
export default {
  name: 'ComingSoonModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    job_opportunity_duration: {
      default: false,
    },
    job_opportunity_price: {
      default: false,
    },
  },
  methods: {
    onModalHidden: function () {
      this.$emit('modal-close');
    },
    onClose: function () {
      this.$emit('modal-close');
    },
    onContinue: function () {
      this.$router.push('/recruiter/sign-up');
    },
    redirectToCalendly() {
      window.open('https://calendly.com/mark-phairify/talk-with-an-expert', '_blank');
      //window.location.href = 'https://calendly.com/mark-phairify/talk-with-an-expert';
    }
  },
};
</script>

<style scoped>
.fw-bold{
  font-weight: bold;
}

</style>
